import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const GetFacilitiesPricingModelsResponseDtoSchema = z.array(
  z.object({
    id: z.number(),
    name: z.string(),
  })
);

export type GetFacilitiesPricingModelsResponseDto = z.infer<
  typeof GetFacilitiesPricingModelsResponseDtoSchema
>;

export const getFacilitiesPricingModels = (config?: AxiosRequestConfig) => {
  return api
    .get('/facilities/pricing-models', config)
    .then(responseContract(GetFacilitiesPricingModelsResponseDtoSchema));
};
